import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AbstractDynamicComponent } from '@components/abstracts';
import { EncartEdito } from '@components/encart-edito/models';
import { ImageComponent } from '@shared/components/image';
import { SvgComponent } from '@shared/components/svg';

@Component({
  selector: 'app-encart-edito',
  templateUrl: './encart-edito.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ImageComponent, SvgComponent],
})
export class EncartEditoComponent extends AbstractDynamicComponent<EncartEdito> {}
